// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes appear-down-data-v-21ed3dc6{0%{transform:translateY(var(--trans))}to{transform:translateY(0)}}@keyframes fade-in-data-v-21ed3dc6{0%{opacity:0}to{opacity:1}}@keyframes kenburns-data-v-21ed3dc6{0%{transform-origin:10% 30%;transform:scale(1)}50%{transform-origin:50% 50%;transform:scale(1.2)}to{transform-origin:80% 90%;transform:scale(1)}}@keyframes fade-data-v-21ed3dc6{0%{opacity:0}to{opacity:1}}.profileMenu__body[data-v-21ed3dc6]{padding:0 12px}", ""]);
// Exports
module.exports = exports;
